import { useContext } from 'react';
import GlobalContext from '../../common/context/global';

export default function useAnalyticsContext() {
  const { analytics } = useContext(GlobalContext);
  return analytics;
}
